import React, { useEffect, useMemo, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { getDealerships, getUsersByDealership } from '../actions/api';
import { tally } from '../scoring';
import StatTable, { STAT_COLUMNS } from './StatTable';

const DealershipDashboard = () => {
  const [dealerships, setDealerships] = useState(null);
  const [selectedId, setSelectedId] = useState('');
  const [reps, setReps] = useState(null);

  useEffect(() => {
    getDealerships()
      .then((list) => {
        setDealerships(list);
        if (list.length) setSelectedId(list[0].id);
      })
      .catch(() => setDealerships([]));
  }, []);

  useEffect(() => {
    if (!selectedId) return;
    setReps(null);
    getUsersByDealership(selectedId).then((users) => setReps(users || []));
  }, [selectedId]);

  const rows = useMemo(
    () => (reps || []).map((u) => ({ id: u.id, name: u.name, ...tally(u.customers) })),
    [reps]
  );
  const totals = useMemo(() => tally((reps || []).flatMap((u) => u.customers)), [reps]);

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>Dealership</h1>
          <p>Results for every rep from a dealership, across all of their bootcamps.</p>
        </div>
        {dealerships && dealerships.length > 1 && (
          <TextField select size="small" label="Dealership" value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)} sx={{ minWidth: 280, width: 'auto' }}>
            {dealerships.map((d) => <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>)}
          </TextField>
        )}
      </div>

      {dealerships && dealerships.length === 0 ? (
        <div className="panel empty-state">
          <h2>No dealership linked</h2>
          <p>Your account isn’t linked to a dealership yet. Ask an ATN admin to connect it.</p>
        </div>
      ) : (
        <>
          <div className="panel dealer-summary" aria-label="Dealership totals">
            {STAT_COLUMNS.filter((c) => c.key !== 'points').map((c) => (
              <div key={c.key}><span className="n">{totals[c.key]}</span><span className="l">{c.label}</span></div>
            ))}
          </div>
          <div className="panel">
            {reps === null ? (
              <div className="loading-line">Loading reps…</div>
            ) : rows.length === 0 ? (
              <div className="empty-state"><p>No reps from this dealership have registered yet.</p></div>
            ) : (
              <StatTable rows={rows} nameLabel="Rep" />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default DealershipDashboard;
